// app/src/app/layouts/MainLayout.jsx
import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@widgets/Header/Header';
import Sidebar from '@widgets/Sidebar/Sidebar';
import Footer from '@widgets/Footer/Footer';

const MainLayout = () => {
  return (
    <div className="layout-wrapper" style={{ 
      display: 'grid',
      gridTemplateRows: 'var(--header-height) 1fr var(--footer-height)',
      height: '100vh',
      overflow: 'hidden'
    }}>
      <Header />

      <div className="main-scroll-container" style={{
        display: 'flex',
        overflow: 'hidden',
        maxWidth: 'var(--container-max-width)',
        margin: '0 auto',
        width: '100%',
        padding: '0 var(--spacing-xl)',
        gap: 'var(--spacing-lg)'
      }}>
        <Sidebar />

        <main className="content-area" id="main-content-area" style={{
          flex: 1,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden',
          padding: 0
        }}>
          <div id="content-scroll-container" style={{
            flex: 1,
            overflowY: 'auto',
            padding: 'var(--spacing-xl) 0',
            position: 'relative'
          }}>
            <Outlet />
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default memo(MainLayout);
